/**
 * Gujarat Serviceable Pincode Ranges
 * 
 * Contains all 26 Gujarat districts with their pincode ranges.
 * Used by PincodeChecker component to validate delivery availability.
 */

export const GUJARAT_DISTRICTS = [
    { name: 'Ahmedabad', start: 380001, end: 383345 },
    { name: 'Amreli', start: 362730, end: 365660 },
    { name: 'Anand', start: 387210, end: 388640 },
    { name: 'Banaskantha', start: 385001, end: 385575 },
    { name: 'Bharuch', start: 391810, end: 394810 },
    { name: 'Bhavnagar', start: 364001, end: 364765 },
    { name: 'Dahod', start: 389110, end: 389382 },
    { name: 'Gandhi Nagar', start: 380060, end: 382855 },
    { name: 'Jamnagar', start: 360110, end: 363655 },
    { name: 'Junagadh', start: 360490, end: 365440 },
    { name: 'Kachchh', start: 370001, end: 370675 },
    { name: 'Kheda', start: 387001, end: 388440 },
    { name: 'Mahesana', start: 382115, end: 384435 },
    { name: 'Narmada', start: 391110, end: 394810 },
    { name: 'Navsari', start: 394730, end: 396590 },
    { name: 'Panch Mahals', start: 388270, end: 389390 },
    { name: 'Patan', start: 384110, end: 385360 },
    { name: 'Porbandar', start: 360490, end: 362650 },
    { name: 'Rajkot', start: 360001, end: 365480 },
    { name: 'Sabarkantha', start: 383001, end: 383462 },
    { name: 'Surat', start: 392150, end: 396510 },
    { name: 'Surendra Nagar', start: 360055, end: 382780 },
    { name: 'Tapi', start: 394365, end: 394680 },
    { name: 'The Dangs', start: 394710, end: 394730 },
    { name: 'Vadodara', start: 388710, end: 393130 },
    { name: 'Valsad', start: 396001, end: 396385 },
];

/**
 * Check if a pincode is serviceable (within Gujarat)
 * @param {string|number} pincode - 6-digit Indian pincode
 * @returns {Object} { valid: boolean, district?: string, message?: string }
 */
export const isServiceable = (pincode) => {
    const pincodeStr = String(pincode).trim();

    // Validate format: must be exactly 6 digits
    if (!/^\d{6}$/.test(pincodeStr)) {
        return {
            valid: false,
            message: 'Please enter a valid 6-digit pincode'
        };
    }

    const pin = parseInt(pincodeStr, 10);

    // Find matching district (Gujarat)
    const district = GUJARAT_DISTRICTS.find(
        d => pin >= d.start && pin <= d.end
    );

    if (district) {
        return {
            valid: true,
            state: 'Gujarat',
            district: district.name,
            message: `Delivery available to ${district.name}, Gujarat`
        };
    }

    // Handled as Rest of India
    return {
        valid: true,
        state: 'India',
        district: 'India',
        message: 'Delivery available to your location'
    };
};

/**
 * Get stored pincode from localStorage
 * @returns {string|null}
 */
export const getSavedPincode = () => {
    try {
        return localStorage.getItem('userPincode');
    } catch {
        return null;
    }
};

/**
 * Save pincode to localStorage
 * @param {string} pincode 
 */
export const savePincode = (pincode) => {
    try {
        localStorage.setItem('userPincode', pincode);
    } catch {
        // localStorage not available
    }
};
